<template>
  <v-footer
    dark
    padless
    class="greydark"
  >
    <v-container>
      <v-row class="py-8">
        <v-col cols="12" md="4" class="mb-4">
          <div class="d-flex align-center mb-4">
            <v-icon size="40" class="logo-footer mr-3">$logoAdaptify</v-icon>
            <span class="text-h6 white--text font-weight-bold">{{ brandText }}</span>
          </div>
          <p class="greylight--text">
            {{ taglineText }}
          </p>
        </v-col>

        <v-col cols="12" md="4" class="mb-4">
          <h3 class="white--text mb-4 font-weight-bold">{{ sectionsTitle }}</h3>
          <v-list dense class="transparent">
            <v-list-item
              v-for="link in currentSectionLinks"
              :key="link.label"
              :href="link.href"
              class="px-0"
            >
              <v-list-item-content>
                <v-list-item-title class="greylight--text">
                  {{ link.label }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>

        <v-col cols="12" md="4" class="mb-4">
          <h3 class="white--text mb-4 font-weight-bold">Soluciones</h3>
          <v-list dense class="transparent">
            <v-list-item
              v-for="link in solutionLinks"
              :key="link.label"
              :to="link.to || undefined"
              :href="link.href || undefined"
              class="px-0"
            >
              <v-list-item-content>
                <v-list-item-title class="greylight--text">
                  {{ link.label }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <v-divider dark></v-divider>

      <v-row class="py-4">
        <v-col cols="12" class="text-center">
          <span class="greylight--text">
            {{ copyrightText }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    vertical: {
      type: String,
      default: 'hub',
      validator: (v) => ['hub', 'tradeflow'].includes(v),
    },
  },
  computed: {
    brandText() {
      return this.vertical === 'tradeflow' ? 'TradeFlow' : 'AdaptifyX';
    },
    taglineText() {
      return this.vertical === 'tradeflow'
        ? 'Gestión inteligente de operaciones de comercio exterior.'
        : 'Soluciones digitales especializadas para industrias que mueven el mundo.';
    },
    sectionsTitle() {
      return this.vertical === 'tradeflow' ? 'Secciones' : 'Navegación';
    },
    sectionLinksMap() {
      return {
        hub: [
          { label: 'Verticales', href: '#verticals' },
          { label: 'Plataforma', href: '#platform' },
          { label: 'Cómo Empezamos', href: '#contact' },
          { label: 'Contacto', href: '#contact' },
        ],
        tradeflow: [
          { label: 'El Problema', href: '#tf-problem' },
          { label: 'La Solución', href: '#tf-solution' },
          { label: 'Planes', href: '#tf-pricing' },
          { label: 'Casos Reales', href: '#tf-cases' },
          { label: 'FAQ', href: '#tf-faq' },
          { label: 'Contacto', href: '#tf-contact' },
        ],
      };
    },
    currentSectionLinks() {
      return this.sectionLinksMap[this.vertical] || this.sectionLinksMap.hub;
    },
    solutionLinks() {
      return [
        {
          label: 'TradeFlow — Comercio Exterior',
          to: '/tradeflow',
          href: null,
        },
        {
          label: 'InsureFlow — Seguros (Próximamente)',
          to: null,
          href: '#contact',
        },
      ];
    },
    copyrightText() {
      return '© 2026 AdaptifyX. Todos los derechos reservados.';
    },
  },
};
</script>

<style lang="scss">
.logo-footer > svg {
  fill: var(--v-primary-base);
}
</style>
